import type React from 'react';
import { useCallback } from 'react';
import NotificationContainer from '../NotificationContainer';
import StackedNotificationsContainer from '../StackedNotificationsContainer';
import { Heading, Modal } from '@zillow/constellation-10';

interface ModalProps {
  body: React.ReactNode;
  dividers?: boolean;
  header: React.ReactNode;
  onRequestClose?: () => void;
  onOpenChange?: () => void;
  footer: React.ReactNode;
  size?: Record<string, any>;
  persona: string;
}
function PaymentsModal({
  body,
  dividers = true,
  footer,
  header,
  onOpenChange,
  onRequestClose,
  size = { base: 'fullScreen', lg: 'md' },
  persona,
}: ModalProps): JSX.Element {
  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onRequestClose?.();
      }
      onOpenChange?.();
    },
    [onRequestClose, onOpenChange],
  );

  const mainContent = (bodyContent) => {
    return (
      <>
        {persona && <NotificationContainer modal persona={persona} />}
        {persona && <StackedNotificationsContainer modal persona={persona} />}
        {bodyContent}
      </>
    );
  };

  return (
    <Modal
      body={mainContent(body)}
      dividers={dividers}
      footer={footer}
      header={<Heading level={2}>{header}</Heading>}
      onOpenChange={handleOpenChange}
      size={size}
      defaultOpen
      closeButton={onRequestClose ? undefined : null}
      useDismissProps={{
        escapeKey: false,
        outsidePress: false,
      }}
    />
  );
}

export default PaymentsModal;
